import { marginMultiplierLabel } from "../utils/marginMultiplier";

/**
 * G-168 (owner ruling 2026-09-29): the multiplier beside a target-margin box,
 * following the boxes as they are typed — "×2.5 before IVA · ×2.75 with IVA".
 * Blank while the margin draft is empty or not a margin under 100.
 */
export function MarginMultiplierHint({
  targetMarginPercent,
  vatRatePercent,
  className = "field-hint",
}: {
  targetMarginPercent: string | number;
  vatRatePercent?: string | number | null;
  className?: string;
}) {
  return (
    <span className={className} aria-live="polite">
      {marginMultiplierLabel(targetMarginPercent, vatRatePercent) ?? ""}
    </span>
  );
}
